import * as reducers from './reducers';
import * as actions from './actions';

export const constants = {
  NAME: 'report'
}

export default { actions, constants, reducers }